var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignJustify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.911621,
    width: 35,
    height: 39,
    rx: 7.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.911621,
    width: 35,
    height: 39,
    rx: 7.5,
    stroke: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12635_16508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 13.4901H27.4167C27.6598 13.4901 27.8929 13.3935 28.0648 13.2216C28.2368 13.0497 28.3333 12.8165 28.3333 12.5734C28.3333 12.3303 28.2368 12.0971 28.0648 11.9252C27.8929 11.7533 27.6598 11.6567 27.4167 11.6567H10.9167C10.6736 11.6567 10.4404 11.7533 10.2685 11.9252C10.0966 12.0971 10 12.3303 10 12.5734C10 12.8165 10.0966 13.0497 10.2685 13.2216C10.4404 13.3935 10.6736 13.4901 10.9167 13.4901Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 19.245H27.4167C27.6598 19.245 27.8929 19.1484 28.0648 18.9765C28.2368 18.8046 28.3333 18.5714 28.3333 18.3283C28.3333 18.0852 28.2368 17.852 28.0648 17.6801C27.8929 17.5082 27.6598 17.4116 27.4167 17.4116H10.9167C10.6736 17.4116 10.4404 17.5082 10.2685 17.6801C10.0966 17.852 10 18.0852 10 18.3283C10 18.5714 10.0966 18.8046 10.2685 18.9765C10.4404 19.1484 10.6736 19.245 10.9167 19.245Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 24.4901H27.4167C27.6598 24.4901 27.8929 24.3935 28.0648 24.2216C28.2368 24.0497 28.3333 23.8165 28.3333 23.5734C28.3333 23.3303 28.2368 23.0971 28.0648 22.9252C27.8929 22.7533 27.6598 22.6567 27.4167 22.6567H10.9167C10.6736 22.6567 10.4404 22.7533 10.2685 22.9252C10.0966 23.0971 10 23.3303 10 23.5734C10 23.8165 10.0966 24.0497 10.2685 24.2216C10.4404 24.3935 10.6736 24.4901 10.9167 24.4901Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 29.8348H27.4167C27.6598 29.8348 27.8929 29.7382 28.0648 29.5663C28.2368 29.3944 28.3333 29.1612 28.3333 28.9181C28.3333 28.675 28.2368 28.4419 28.0648 28.27C27.8929 28.098 27.6598 28.0015 27.4167 28.0015H10.9167C10.6736 28.0015 10.4404 28.098 10.2685 28.27C10.0966 28.4419 10 28.675 10 28.9181C10 29.1612 10.0966 29.3944 10.2685 29.5663C10.4404 29.7382 10.6736 29.8348 10.9167 29.8348Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3093 29.83H27.0207C27.368 29.83 27.701 29.7336 27.9465 29.562C28.1921 29.3904 28.33 29.1577 28.33 28.915C28.33 28.6723 28.1921 28.4396 27.9465 28.268C27.701 28.0964 27.368 28 27.0207 28H11.3093C10.962 28 10.629 28.0964 10.3835 28.268C10.1379 28.4396 10 28.6723 10 28.915C10 29.1577 10.1379 29.3904 10.3835 29.562C10.629 29.7336 10.962 29.83 11.3093 29.83Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12635_16508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white",
    transform: "translate(8 10.4116)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignJustify);
export default __webpack_public_path__ + "static/media/align-justify.25ae2828edfc5d9cb869f95e8366bffc.svg";
export { ForwardRef as ReactComponent };